export const userRoles = {
    admin : 'administrator',
    superUser : 'super-user',
    buyer : 'buyer',
    viewOnly : 'view-only'
};
